<template>
  <v-menu
    v-model="showMenu"
    :disabled="disableMenu"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on: onMenu }">
      <v-tooltip bottom :disabled="disableTooltip">
        <template v-slot:activator="{ on: onTooltip }">

          <div v-if="checkDeliveryItem(schedule)" :style="getDeliveryIconStyle(schedule)" v-on="onMenu">
            <div v-on="onTooltip">
              <img v-if="checkDeliveryState(schedule)" src="../assets/archive.png" class="delivery-icon">
              <img v-else src="../assets/archive_grey.png" class="delivery-icon">
            </div>
          </div>

          <div v-else :style="getScheduleStyle(schedule)" v-on="onMenu">
            <div
              class="inside-bar"
              v-on="onTooltip"
              :style="getInsideScheduleStyle(schedule)"
            ></div>
          </div>
        </template>
        <slot name="tooltipInfo" :item="schedule"></slot>
      </v-tooltip>
    </template>
    <v-list>
      <slot name="menuInfo" :item="schedule"></slot>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    schedule: {
      type: Object,
    },
    selectedDate: {
      type: String
    },
    start: {
      type: Number,
    },
    end: {
      type: Number,
    },
    contentWidth: {
      type: Number,
    },
    unitWidth: {
      type: Number,
    },
    disableMenu: {
      type: Boolean,
      default: false,
    },
    disableTooltip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {},
  methods: {
    getScheduleStyle(schedule) {
      const borderColor = this.getScheduleBorder(schedule);
      return {
        position: "absolute",
        backgroundColor: schedule.color,
        left: this.getSchedulePosition(schedule),
        width: this.getScheduleWidth(schedule),
        boxShadow: 'inset 0px 0px 2px 1px '+ borderColor, //rgba(153, 153, 153, 0.76)',
        height: "14px",
      };
    },
    getInsideScheduleStyle(schedule) {
      if (
        schedule.item &&
        schedule.item.resrvState &&
        schedule.item.resrvState.configValue === "rs_done"
      )
      return {
        background: "linear-gradient(45deg, #333333, #333333 25%, transparent 25%, transparent 50%, #333333 50%, #333333 75%, transparent 75%, transparent)",
        backgroundSize: "6px 6px"
      };
    },
    getSchedulePosition(schedule) {
      const startTime = this.$func.stringToDatetime(schedule.startTime);
      const baseTime = this.$func.stringToDate(this.selectedDate);
      baseTime.set({hours: 0, minutes: 0, seconds: 0});
      const startPosition = this.$moment
        .duration(startTime.diff(baseTime))
        .asMinutes();

      return startPosition * this.unitWidth + "px";
    },
    getScheduleWidth(schedule) {
      const startTime = this.$func.stringToDatetime(schedule.startTime);
      const endTime = this.$func.stringToDatetime(schedule.endTime);
      let duration = this.$moment
        .duration(endTime.diff(startTime))
        .asMinutes();

      if (duration <= 3) {
        duration = 3
      }

      return duration * this.unitWidth + "px";
    },
    getScheduleBorder(schedule) {
      return this.getHexToAgbColor(schedule.color) || schedule.color;
    },
    getHexToAgbColor(hexColor) {
      if (hexColor.indexOf("#") < 0 || hexColor.length !== 7) {
        return null;
      }
      let r = hexColor.substring(1, 3);
      let g = hexColor.substring(3, 5);
      let b = hexColor.substring(5, 7);

      r = parseInt(r, 16) - 30;
      r = r < 0 ? 0 : r;
      g = parseInt(g, 16) - 30;
      g = g < 0 ? 0 : g;
      b = parseInt(b, 16) - 30;
      b = b < 0 ? 0 : b;

      return "rgb(" + r + ", " + g + ", " + b + ")";
    },
    checkDeliveryItem(schedule) {
      return schedule.category === 'delivery';
    },
    checkDeliveryState(schedule) {
      return schedule.item.state.configValue === 'dvry_to_be_done';
    },
    getDeliveryIconStyle(schedule) {
      return {
        position: "absolute",
        left: this.getSchedulePosition(schedule),
      }
    }

  },
  mounted() {},
};
</script>
<style scoped>
.inside-bar {
  width: 100%;
  height: 100%;
}
.delivery-icon {
  height: 13px;
  margin-top: 15px;
}
</style>
